module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0079.jpg?v=dc2d277d";